/**
 * The Emails area's sections and paths, with no component imports, so the sidebar (in the eager shell
 * bundle) can mark Emails active without pulling the Emails page chrome into that bundle.
 */

/** Left to right as the spec orders them. Campaigns is the area's landing page. */
export const EMAIL_SECTIONS = [
  { value: "campaigns", label: "Campaigns", to: "/emails" },
  { value: "templates", label: "Templates", to: "/emails/templates" },
  { value: "contacts", label: "Contacts", to: "/emails/contacts" },
  { value: "segments", label: "Segments", to: "/emails/segments" },
  {
    value: "transactional",
    label: "Transactional",
    to: "/emails/transactional",
  },
  { value: "trustpilot", label: "Trustpilot", to: "/emails/trustpilot" },
  { value: "brand", label: "Brand", to: "/emails/brand" },
] as const;

export type EmailSection = (typeof EMAIL_SECTIONS)[number]["value"];

/** True on any Emails page, and on the old URLs that redirect into it. */
export function isEmailsPath(pathname: string): boolean {
  return (
    pathname === "/emails" ||
    pathname.startsWith("/emails/") ||
    pathname === "/notifications" ||
    pathname.startsWith("/notifications/") ||
    pathname === "/trustpilot"
  );
}
